import Carousel from '../components/Carousel'
import Contact from '../components/Contact'
import Feedbacks from '../components/Feedbacks'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import IdeaSectionAbout from '../section/IdeaSectionAbout'
import SocialMediaHero from '../section/SocialMediaHero'
import PartnersLogos from '../components/PartnersLogos'
import React from 'react'
import { Helmet } from 'react-helmet';
import IdeaSSMSect from '../section/IdeaSSMSect'


function SocialMedia() {
  return (
    <div className="relative z-0 bg-[#060816]">
        <Helmet>
<title>Social Media Marketing - The Designsinc.</title>
</Helmet>

    <div>
      <Navbar />
      <div>
        {/** About Section */}
       <SocialMediaHero />
     {/**Slider logos company */}
     <PartnersLogos />

        {/**idea section and btns */}
        <IdeaSSMSect />

        {/** Testimonials */}
        <div className="">
        <Feedbacks  />
        </div>
        {/** contact section */}
        <div className='relative z-0'>
      <Contact />
     
    </div>
      </div>
    </div>

    <Footer />
  </div>
  )
}

export default SocialMedia